export default __webpack_public_path__ + "static/media/iread.725d68c6.jpg";